import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { recordTypes } from "../../../../API/config";
import { AttributeGroup, NoAccessScreen } from "../../../../Component";
import EndityDocuments from "../../../EntityDocuments";
import EntityAssociations from "../../../EntityAssociations";
import CountryRiskScores from "../CountryRiskScores";
import EntityLinks from "../../../EntityLinks";
import styles from "./styles";

const AML = (props) => {
  const {
    classes,
    entity,
    onAssociationUpdate,
    handleOnChange,
    handleOnUnitChange,
    reloadEntity,
    hasRecordPermission,
    hasPermission,
    user,
    listOptions,
    amlAttributes,
  } = props;
  const { confidential } = entity || {};

  const [canViewAmlFields, setCanViewAmlFields] = useState();
  const [canViewAmlDocuments, setCanViewAmlDocuments] = useState();
  const [canViewAssociations, setCanViewAssociations] = useState();
  const [canViewLinks, setCanViewLinks] = useState();
  const [canViewSensitiveFields, setCanViewSensitiveFields] = useState();
  const [maskSensitive, setMaskSensitive] = useState(false);
  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => {
    const setPermissions = async () => {
      const { permissions = {} } = entity;
      const canViewAmlFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewAmlFields.name
      );
      await setCanViewAmlFields(canViewAmlFields);

      const canViewAmlDocuments = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewAmlDocuments.name
      );
      setCanViewAmlDocuments(canViewAmlDocuments);

      const canViewAssociations = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewAssociations.name
      );
      setCanViewAssociations(canViewAssociations);

      const canViewLinks = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewAmlLinks.name
      );
      setCanViewLinks(canViewLinks);

      const canViewSensitiveFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewSensitiveFields.name
      );
      setCanViewSensitiveFields(canViewSensitiveFields);

      if (confidential && !canViewSensitiveFields) {
        setMaskSensitive(true);
      }
      setLoaded(true);
    };
    setPermissions();
  }, [entity]);

  if (isLoaded && !canViewAmlFields) {
    return <NoAccessScreen />;
  }

  const handleChange = (attrId, newValue) => {
    handleOnChange(attrId, newValue);
  };

  const handleUnitChange = (attrId, newUnitValue) => {
    handleOnUnitChange(attrId, newUnitValue);
  };

  const renderAttributes = () => {
    const subSectionElements = [];
    for (let sc in amlAttributes) {
      subSectionElements.push(
        <div key={sc} className={classes.inputContainerStyle}>
          <AttributeGroup
            attributes={amlAttributes[sc]}
            maskSensitive={maskSensitive}
            onChange={handleChange}
            onUnitChange={handleUnitChange}
            listOptions={listOptions}
          />
        </div>
      );
    }
    return subSectionElements;
  };

  return (
    <div className={classes.pageContent}>
      <CountryRiskScores entity={entity} />
      {renderAttributes()}
      {(!confidential || canViewSensitiveFields) && canViewAssociations && (
        <EntityAssociations
          entity={entity}
          hasRecordPermission={hasRecordPermission}
          hasPermission={hasPermission}
          onUpdate={onAssociationUpdate}
          user={user}
        />
      )}
      {(!confidential || canViewSensitiveFields) && canViewAmlDocuments && (
        <EndityDocuments
          entity={entity}
          category="AML"
          reloadEntity={reloadEntity}
          hasRecordPermission={hasRecordPermission}
        />
      )}
      {(!confidential || canViewSensitiveFields) && canViewLinks && (
        <EntityLinks
          entity={entity}
          type="AML"
          hasRecordPermission={hasRecordPermission}
        />
      )}
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(AML);
